var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}],staticClass:"yy-select-dropdown",class:_vm.className,style:(_vm.styles),attrs:{"data-transfer":_vm.transfer}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }